import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiselectComponent from "../components/MultiselectComponent";
import {
  getOutputColumnsData,
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import { showAddedRulesToast } from "../helpers";
const initialObjectProperties = {
  appliedRule: 11,
  inputColumns: [],
  mergeTo: "",
  mergeDestination: "",
  ruleName: "Merge Columns",
};

const MergeColumns = () => {
  const dispatch = useDispatch();
  const [mergeColumns, setMergeColumns] = useState(initialObjectProperties);
  const [selectInputcols, setselectInputcols] = useState();
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag); // unsaved changes flag

  useEffect(() => {
    if (state?.type === "mergeColumns") {
      setMergeColumns((prev) => ({ ...prev, ...state.data }));
      setselectInputcols(
        state.data.inputColumns.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const handlesetselectInputcols = (selectedOptions) => {
    setselectInputcols(selectedOptions);
    const selectedValues = selectedOptions.map((sel) => sel.value);

    setMergeColumns({
      ...mergeColumns,
      inputColumns: selectedValues, // Selected column keys
    });
  };

  const mergeToColumnsData =
    mergeColumns.mergeDestination === "inputFile"
      ? inputColsData.map((item) => ({
          label: item.inColChr,
          value: item.inColChr,
        }))
      : outputColsData.map((item) => ({
          label: item.outColChr,
          value: item.outColChr,
        }));

  const handleOnChange = (e) => {
    setMergeColumns((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });

    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    dispatch(saveAsMappings(mergeColumns));
    showAddedRulesToast(
      mergeColumns.appliedRule,
      isInLocalEditMode ? "Updated" : "added"
    ); // Show toast notification
    reset();
  };
  const reset = () => {
    setselectInputcols("");
    setMergeColumns(initialObjectProperties);
    setIsInLocalEditMode(false);
  };
  const toggleValue = (value) => {
    setMergeColumns((prev) => ({ ...prev, mergeDestination: value }));
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
      <p className="">Select Destination File</p>
      <div className="col-span-2  flex justify-between items-center">
        <div className="flex gap-2 p-1 bg-gray-200 rounded-lg">
          <button
            className={`px-4 py-2 rounded-md transition ${
              mergeColumns.mergeDestination === "inputFile"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 opacity-70"
            }`}
            onClick={() => toggleValue("inputFile")}
          >
            Input File
          </button>
          <button
            className={`px-4 py-2 rounded-md transition ${
              mergeColumns.mergeDestination === "outputFile"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 opacity-70"
            }`}
            onClick={() => toggleValue("outputFile")}
          >
            Output File
          </button>
        </div>
      </div>

      <MultiselectComponent
        options={inputColsData.map((item) => ({
          label: item.inColChr,
          value: item.inColChr,
        }))}
        selectedOptions={selectInputcols}
        handleSetSelect={handlesetselectInputcols} // Handle the selection change
        label={"Select Input Columns"}
        required={true}
      />

      <DropDownMenu
        label="Merge To Column"
        name="mergeTo"
        value={mergeColumns.mergeTo}
        options={mergeToColumnsData}
        onChange={(e) => handleOnChange(e)}
        required={true}
      />

      <div className="mt-4 col-span-2 flex gap-2">
        <Button
          btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
          handleOnClick={handleAddNewRule}
          disabled={
            !(
              mergeColumns.inputColumns.length &&
              mergeColumns.mergeTo &&
              mergeColumns.mergeDestination
            )
          }
        />
        <Button btnType="cancel" btnText={"Reset"} handleOnClick={reset} />
      </div>
    </div>
  );
};

export default MergeColumns;
